import React from 'react';
import {Content, PolicyWrapper, Text, Title} from "./style";
import {Container} from "../../common/style/Container";
import {Link} from 'react-router-dom';
import {ROUTS} from "../../common/constans/routs";

export const Policy = () => {
    return (
        <PolicyWrapper>
            <Container>
                <Content>
                    <Title>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</Title>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>1. Общие положения</Title>
                    <Text>
                        <b>1.1.</b> Политика обработки персональных данных (далее – «Политика») действует в отношении всех
                        Персональных данных (как определено ниже), которые Общество с ограниченной ответственностью « ИП TOP CAR »
                        может получить о Пользователях онлайн-сервиса CarClav использовании ими Сервиса (как определено ниже).
                    </Text>
                    <Text>
                        <b>1.2.</b> Целью Политики является обеспечение надлежащей защиты Персональных данных от несанкционированного
                        доступа и распространения.
                    </Text>
                    <Text>
                        <b>1.3.</b> Отношения, связанные с обработкой Персональных данных Пользователей и Клиентов, регулируются в
                        соответствии с настоящей Политикой, Федеральным законом от 27 июля 2006 года № 152-ФЗ «О персональных данных»
                        (далее – ФЗ «О персональных данных») и иными нормативными правовыми актами Российской Федерации в сфере
                        обработки Персональных данных.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>2. Термины и определения</Title>
                    <Text>
                        <b>2.1.</b> Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или
                        определяемому физическому лицу (субъекту персональных данных).
                    </Text>
                    <Text>
                        <b>2.2.</b> Специальные категории Персональных данных – Персональные данные, касающиеся расовой, национальной
                        принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной
                        жизни субъекта персональных данных.
                    </Text>
                    <Text>
                        <b>2.3.</b> Оператор персональных данных (далее – Оператор) – Общество с ограниченной ответственностью « ИП TOP
                        CAR » (Адрес: Казахстан, Алматы, Байтурсынова 179/2, БИН (ИИН): 011006500064. Банк: АО "Kaspi Bank", КБе:
                        19. БИК: CASPKZKA, Номер счета: KZ05722S000024869194) — организация, самостоятельно организующая и осуществляющая
                        обработку персональных данных, а также определяющая цели обработки персональных данных, состав персональных
                        данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.
                    </Text>
                    <Text>
                        <b>2.4.</b> Клиент – юридическое или физическое лицо, которые определяют цели обработки персональных данных, состав
                        персональных данных, подлежащих обработке, действия (операции), совершаемые с Персональными данными (когда такая
                        обработка осуществляется Оператором по поручению указанных лиц).
                    </Text>
                    <Text>
                        <b>2.5.</b> Пользователь (субъект персональных данных) – физическое лицо, использующее онлайн-сервис в соответствии
                        с условиями Пользовательского соглашения.
                    </Text>
                    <Text>
                        <b>2.6.</b> Онлайн-сервис «CAR CLAV» (далее – Сервис) – Платформа для аренды автомобилей, объединяющая автопрокаты, частных
                        владельцев автомобилей и клиентов.
                    </Text>
                    <Text>
                        <b>2.7.</b> Пользовательское соглашение – соглашение, заключенное между Пользователем и Оператором, содержащее все
                        необходимые и существенные условия предоставления и использования Пользователем доступа к онлайн-сервису. Пользовательское соглашение
                        размещено по адресу сarclav.veon-tech.by.
                    </Text>
                    <Text>
                        <b>2.8.</b> Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с
                        Персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка
                        персональных данных включает в себя, в том числе сбор, запись, систематизацию, накопление, хранение, использование,
                        уточнение (обновление, изменение), извлечение, передачу (распространение, предоставление, доступ), обезличивание,
                        блокирование, удаление, уничтожение.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>3. Цели сбора Персональных данных</Title>
                    <Text>
                        <b>3.1.</b> Оператор осуществляет Обработку персональных данных в следующих целях:
                    </Text>

                            <Text>
                                (а) заключения и исполнения Пользовательского соглашения, в том числе для предоставления Пользователям
                                возможности использования Сервиса, прохождения опросов и тестирования, коммуникации между Пользователями,
                                связи Оператора с Пользователем, включая направление уведомлений, запросов и информации, касающихся
                                использования Сервиса;
                            </Text>

                            <Text>
                                (б) улучшения качества Сервиса, удобства его использования, разработки нового функционала, в том числе путем
                                анализа результатов использования Сервиса;
                            </Text>

                            <Text>
                                (в) проведения статистических и иных исследований на основе обезличенных Персональных данных;
                            </Text>

                            <Text>
                                (г) исполнения поручений Клиентов по Обработке персональных данных;
                            </Text>

                            <Text>
                                (д) информирования о новых продуктах и услугах, специальных предложениях и различных событиях, связанных с
                                деятельностью Оператора;
                            </Text>

                            <Text>
                                (е) обработки запросов Пользователей о предоставлении доступа к Персональным данным и обращений об уточнении
                                или уничтожении Персональных данных и иных запросов и обращений.
                            </Text>


                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>4. Правовые основания Обработки Персональных данных</Title>
                    <Text>
                        <b>4.1.</b> Обработка персональных данных осуществляется с соблюдением принципов законности и справедливости. Согласно
                        статье 6 ФЗ «О персональных данных». Обработка персональных данных возможна только при наличии предусмотренных законом
                        оснований.
                    </Text>
                    <Text>
                        <b>4.2.</b> Оператор осуществляет Обработку персональных данных на следующих законных основаниях:
                    </Text>

                            <Text>
                                (а) для целей заключения и исполнения Пользовательского соглашения, включая улучшение качества Сервиса,
                                удобства его использования, разработки нового функционала, анализа результатов использования Сервиса на основании
                                пункта 5 части 1 статьи 6 ФЗ «О персональных данных»;
                            </Text>

                            <Text>
                                (б) для проведения статистических и иных исследований на основе обезличенных Персональных данных в соответствии с
                                пунктом 9 части 1 статьи 6 ФЗ «О персональных данных»;
                            </Text>

                            <Text>
                                (в) для целей информирования о новых продуктах и услугах, специальных предложениях и различных событиях, связанных
                                с деятельностью Оператора, на основании согласия на Обработку персональных данных;
                            </Text>

                            <Text>
                                (г) для целей обработки запросов Пользователей о предоставлении доступа к Персональным данным и обращений Пользователей
                                об уточнении или уничтожении Персональных данных и иных запросов и обращений;
                            </Text>

                            <Text>
                                (д) для целей осуществления прав и законных интересов Оператора или третьих лиц;
                            </Text>

                            <Text>
                                (е) для целей исполнения поручений Клиентов по Обработке персональных данных.
                            </Text>

                    <Text>
                        <b>4.3.</b> Обработка Специальных категорий персональных данных осуществляется на основании согласия в письменной форме
                        на Обработку персональных данных.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>5. Отзыв согласия на Обработку Персональных данных</Title>
                    <Text>
                        <b>5.1.</b> Согласие на Обработку персональных данных, а также согласие на Обработку персональных данных для целей информирования
                        о новых продуктах и услугах, специальных предложениях и различных событиях, связанных с деятельностью Оператора, может быть
                        отозвано Пользователем в любой момент.
                    </Text>
                    <Text>
                        <b>5.2.</b> Отзыв согласия направляется Пользователем Оператору по адресу электронной почты: info@impulse-lms.com или иным
                        способом, предусмотренным в согласии на Обработку персональных данных.
                    </Text>
                    <Text>
                        <b>5.3.</b> С момента получения Оператором отзыва согласия на Обработку персональных данных Пользователя Оператор утрачивает право
                        на продолжение Обработки персональных данных Пользователя, указанных в данном ранее согласии на Обработку персональных данных.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>6. Объем и категории обрабатываемых Персональных данных</Title>
                    <Text>
                        <b>6.1.</b> Для целей заключения и исполнения Пользовательского соглашения Оператор собирает и обрабатывает следующие
                        Персональные данные:
                    </Text>

                            <Text>(а) фамилию, имя и отчество;</Text>

                            <Text>(б) место работы/учебы;</Text>

                            <Text>(в) сведения об образовании;</Text>

                            <Text>(г) серию, номер паспорта, кем и когда выдан;</Text>

                            <Text>(д) дату рождения, город проживания;</Text>

                            <Text>(е) адрес электронной почты, номер телефона;</Text>

                            <Text>(ж) данные, полученные в результате прохождения Пользователем опросов и тестов;</Text>

                            <Text>(з) Специальные категории Персональных данных в том случае, если Пользователь предоставит Онлайн-сервису такие данные
                                в открытых формах Онлайн-сервиса.</Text>

                            <Text>(и) иные персональные данные, указанные в Приложении № 1 в настоящей Политике, расположенном по адресу:
                                impulse-lms.com/privacy-policy.
                            </Text>


                    <Text>
                        <b>6.2.</b> В целях улучшения качества Сервиса, удобства его использования, разработки нового функционала, анализа результатов
                        использования Сервиса Оператор обрабатывает cookie-файлы, позволяющие отслеживать активность Пользователя в рамках Сервиса.
                        Пользователь вправе в любое время изменить настройки сохранения cookie-файлов в настройках своего браузера, в том числе запретив их сохранение.
                    </Text>

                    <Text>
                        <b>6.3.</b> Оператор собирает и обрабатывает Персональные данные следующих категорий Пользователей:
                    </Text>

                        <Text>(а) совершеннолетними гражданами Российской Федерации;</Text>
                        <Text>(б) несовершеннолетними гражданами Российской Федерации в возрасте от 14 до 18 лет;</Text>
                        <Text>(в) несовершеннолетними гражданами Российской Федерации (персональные данные указанной категории лиц собираются и обрабатываются исключительно на основании согласия в письменной форме законных представителей) в возрасте:</Text>
                        <Text> — от 12 до 14 лет;</Text>
                        <Text> — от 6 до 12 лет;</Text>
                        <Text> — от 2 до 6 лет.</Text>


                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>7. Порядок и условия Обработки персональных данных</Title>
                    <Text>
                        <b>7.1.</b> Сбор Персональных данных осуществляется Оператором при регистрации Пользователя, а также в дальнейшем при внесении
                        Пользователем по своей инициативе дополнительных Персональных данных при использовании Сервиса.
                    </Text>
                    <Text>
                        <b>7.2.</b> Оператор осуществляет автоматизированную обработку Персональных данных с помощью средств вычислительной техники,
                        а также без использования таких средств в случае, если Персональные данные содержатся в документах на бумажных носителях,
                        систематизированных Оператором по определенному алгоритму («смешанная» Обработка персональных данных).
                    </Text>
                    <Text>
                        <b>7.3.</b> В процессе Обработки персональных данных Пользователей Оператор осуществляет следующие действия: сбор, запись,
                        систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление,
                        уничтожение Персональных данных и иные действия.
                    </Text>
                    <Text>
                        <b>7.4.</b> Оператор обязуется не раскрывать третьим лицам и не распространять Персональные данные без согласия Пользователя,
                        если иное не предусмотрено законодательством Российской Федерации. Оператор вправе дать поручение на Обработку персональных
                        данных сторонней организации при условии согласия Пользователя.
                    </Text>
                    <Text>
                        <b>7.5.</b> Срок Обработки персональных данных ограничен достижением целей Обработки персональных данных или сроком действия
                        согласия Пользователя на обработку специальных категорий Персональных данных, а также согласия Пользователя на Обработку
                        персональных данных в целях информирования о новых продуктах и услугах, специальных предложениях и различных событиях,
                        связанных с деятельностью Оператора.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>8. Запрос о предоставлении доступа к Персональным данным</Title>
                    <Text>
                        <b>8.1.</b> Пользователь имеет право на получение информации, касающейся Обработки его персональных данных, в том числе содержащей:
                    </Text>
                    <Text>(а) подтверждение факта Обработки персональных данных;</Text>
                        <Text>(б) правовые основания и цели Обработки персональных данных;</Text>
                        <Text>(в) цели и применяемые Оператором способы Обработки персональных данных.</Text>

                    <Text>
                        <b>8.2.</b> Для получения информации, касающейся Обработки персональных данных Пользователю необходимо направить Оператору запрос
                        о предоставлении доступа к Персональным данным.
                    </Text>
                    <Text>
                        <b>8.3.</b> Запрос должен содержать:
                        (а) серию и номер документа, удостоверяющего личность Пользователя/Клиента;
                        (б) сведения о дате выдачи и органе, выдавшем документ, удостоверяющий личность Пользователя/Клиента;
                        (в) сведения, подтверждающие факт Обработки персональных данных.
                    </Text>
                    <Text>
                        <b>8.4.</b> Оператор обязан сообщить Пользователю информацию об осуществляемой им Обработке персональных данных в течение 10 (десяти)
                        календарных дней с момента получения запроса либо представить в указанный срок мотивированный письменный отказ.
                    </Text>
                    <Text>
                        <b>8.5.</b> Запрос о предоставлении доступа к Персональным данным направляется по адресу электронной почты: clients@rizoft.by.
                        Ответ на запрос направляется по адресу электронной почты, с которого поступил указанный запрос.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>9. Организационные и технические меры</Title>
                    <Text>
                        <b>9.1.</b> Оператор предпринимает организационные и техничесные меры, направленные на обеспечение безопасности Персональных данных
                        Пользователей, в том числе:
                    </Text>

                        <Text>(а) использует шифрование трафика для предотвращения несанкционированного доступа к Персональным данным;</Text>
                        <Text>(б) изолирует Информационную систему персональных данных от прямого доступа из сети Интернет;</Text>
                        <Text>(в) назначает лицо, ответственное за Обработку персональных данных;</Text>
                        <Text>(г) разрабатывает и принимает локальные акты (внутренние документы – приказы, положения, регламенты), устанавливающие процедуры, направленные на предотвращение незаконного доступа к Персональным данным;</Text>
                        <Text>(д) осуществляет внутренний контроль за соответствием Обработки персональных данных требованиям законодательства в области персональных данных, а также принятым Оператором локальным актам;</Text>
                        <Text>(е) проводит обучение и переподготовку сотрудников, участвующих в Обработке персональных данных;</Text>
                        <Text>(ж) проводит оценку эффективности принимаемых мер по обеспечению безопасности Персональных данных;</Text>
                        <Text>(з) устанавливает правила доступа к Персональным данным, обрабатываемым на сервере Персональных данных, а также обеспечивает учет действий, совершаемых с Персональными данными в Информационной системе персональных данных.</Text>

                    <Text>
                        <b>9.2.</b> Информационная система персональных данных расположена на серверах, находящихся на территории Российской Федерации, что обеспечивает
                        выполнение Оператором требований законодательства Российской Федерации о локализации Персональных данных граждан Российской Федерации на территории РФ.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>10. Уничтожение Персональных данных</Title>
                    <Text>
                        <b>10.1.</b> При достижении целей Обработки, Оператор прекращает Обработку и обеспечивает уничтожение Персональных данных в срок, установленный локальными актами Оператора.
                    </Text>
                    <Text>
                        <b>10.2.</b> В случае отзыва Пользователем согласия на Обработку персональных данных Оператор прекращает Обработку и обеспечивает уничтожение Персональных данных в срок, не превышающий 30 (тридцати) календарных дней с момента получения отзыва согласия Пользователя Клиента на Обработку персональных данных.
                    </Text>
                    <Text>
                        <b>10.3.</b> Уничтожение Персональных данных подразумевает удаление Персональных данных с серверов Оператора в случае автоматизированной обработки, и (или) уничтожение материальных носителей в случае смешанной Обработки персональных данных, в результате которых восстановление содержания Персональных данных становится невозможным.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>11. Обращения об уточнении или уничтожении Персональных данных</Title>
                    <Text>
                        <b>11.1.</b> Если Персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели Обработки, Пользователь вправе направить Оператору обращение об уточнении или уничтожении Персональных данных.
                    </Text>
                    <Text>
                        <b>11.2.</b> При выявлении неточных Персональных данных Оператор обязан уточнить Персональные данные в течение 7 (семи) рабочих дней со дня подтверждения Пользователем неточности.
                    </Text>
                    <Text>
                        <b>11.3.</b> При выявлении неправомерной Обработки Оператор обязан прекратить неправомерную Обработку в течение 3 (трех) рабочих дней и уничтожить неправомерно обрабатываемые Персональные данные в течение 10 (десяти) рабочих дней с момента выявления неправомерной Обработки персональных данных.
                    </Text>
                    <Text>
                        <b>11.4.</b> Обращения об уточнении или уничтожении Персональных данных необходимо направлять по адресу электронной почты: clients@rizoft.by. Уведомления, касающиеся уточнения или уничтожения Персональных данных, направляются по адресу электронной почты, с которого поступило обращение.
                    </Text>

                    <Title style={{ fontSize: '1.2rem', marginTop: 24 }}>12. Заключительные положения</Title>
                    <Text>
                        <b>12.1.</b> Использование Сервиса означает безоговорочное согласие Пользователя с Политикой и указанными в ней условиями сбора и обработки Персональных данных. В случае несогласия с этими условиями Пользователь должен воздержаться от использования Сервиса.
                    </Text>
                    <Text>
                        <b>12.2.</b> Политика постоянно размещена в сети Интернет по адресу: сarclav.veon-tech.by. Оператор оставляет за собой право изменять или дополнять Политику в любой момент.
                    </Text>

                </Content>
            </Container>
        </PolicyWrapper>
    );
};

